import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import SVGIcon from "../../../../utils/SVGIcon";
import { validations } from "../../../../config/validations/validations";
import { addNewPortedOutFromUsReport } from "../../../../store/portedOutFromUsReportsSlice";

const AddReport: React.FC<any> = (props) => {
  const { handleAddModal, openAddModal, getList } = props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = (data: { year: number; month: number }) => {
    setLoading(true);
    const payload = {
      year: data.year,
      month: data.month,
    };

    dispatch(addNewPortedOutFromUsReport(payload))
      .then((res: any) => {
        handleAddModal();
        getList();
      })
      .catch((error: any) => {
        console.log("error", error);

        // handleAddModal();
        // getList();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  return (
    <Modal
      open={openAddModal}
      destroyOnClose
      width={900}
      onCancel={handleAddModal}
      closeIcon={<FontAwesomeIcon icon={faTimes} />}
      footer={false}
      className="addModal"
      title={`Add Ported Out From Us Report`}
    >
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
      >
        <Row gutter={20} align={"middle"}>
          <Col xs={24} md={8}>
            <InputBox.Text
              label="Year"
              name={"year"}
              required
              rules={[
                validations.required.text("Year"),
                validations.pattern.numeric,
                validations.pattern.whitespace,
                validations.custom.minYear("Year"),
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              label="Month"
              name={"month"}
              required
              rules={[
                validations.required.text("Month"),
                validations.pattern.numeric,
                validations.pattern.whitespace,
                validations.custom.monthRange("Month"),
              ]}
            />
          </Col>
        </Row>
        <Row gutter={[20, 20]} className="mt-20">
          <Col xs={12} md={12} lg={6}>
            <Button type="primary" htmlType="submit" loading={loading}>
              <SVGIcon icon="add" color="#fff" width={55} /> Add Report
            </Button>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </Modal>
  );
};

export default AddReport;
